export const initPolicyRule = {
  name: '',
  notes: '',
  valid_from: '',
  valid_until: '',
  action_type: '',
  action_config: {},
  conditions: [],
}
